import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { Variants } from '../variant/variant';
import { ComponentVariant } from '../variant/variant';

@Component({
  selector: 'rt-placeloader',
  templateUrl: './placeloader.component.html',
  styleUrls: ['./placeloader.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.light]': '!dark',
    '[class.dark]': 'dark',
    '[class.short]': 'short',
    '[class]': 'variant',
  },
  standalone: true,
})
export class PlaceloaderComponent {
  public static readonly VARIANTS: Variants = ['text', ['text', 'item']];
  @ComponentVariant(PlaceloaderComponent.VARIANTS)
  @Input()
  public variant: string;

  @Input() public dark: boolean = false;
  @Input() public short: boolean = false;
}
